module.exports = __webpack_public_path__ + "static/media/adidas.83213328.png";